import {ListModel} from '@shared/models/list.model';
import {DossierHistoryModel} from './dossier-history.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class DossierHistoryListModel extends ListModel<DossierHistoryModel> {
	constructor(model?: any) {
		super(model);
		this.items = [];
		if (!Utilities.isVoid(model) && !Utilities.isVoid(model.items)) {
			model.items.forEach(dossier => this.items.push(new DossierHistoryModel(dossier)));
		}
	}
}
